var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"left":"","color":"red darken-2"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('router-link',{attrs:{"to":'/races/' + _vm.race}},[_c('img',_vm._g({attrs:{"src":_vm.getRaceImagePath(_vm.race),"alt":_vm.race}},on))])]}}])},[_c('span',[_vm._v(_vm._s(_vm._f("capitalizeWords")(_vm.race)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }